import React, { useEffect } from 'react'

import Box from './box'

import './ui.scss'

const Overlay = ({ onClick }) => {
  useEffect(() => {
    document.body.classList.add('overlayed')

    return () => document.body.classList.remove('overlayed')
  }, [])

  return (
    <Box
      className="m-overlay"
      onClick={onClick}
    />
  )
}

export default Overlay
